import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "submit"];

  refresh() {
    let valid = true;

    this.inputTargets.forEach((input) => {
      const source = parseFloat(input.dataset.source);
      const precision = parseInt(input.dataset.precision, 10);
      const hint = input.parentElement.querySelector(".split-remaining");

      if (input.value === "") {
        hint.textContent = `${this.format(source, precision)} available`;
        hint.classList.remove("text-danger");
        valid = false;
        return;
      }

      const value = parseFloat(input.value);
      const remaining = source - value;

      if (isNaN(value) || value <= 0 || remaining < 0) {
        hint.textContent = `Must be between 0 and ${this.format(source, precision)}`;
        hint.classList.add("text-danger");
        valid = false;
      } else {
        hint.textContent =
          `${this.format(value, precision)} to new article · ` +
          `${this.format(remaining, precision)} stays here`;
        hint.classList.remove("text-danger");
      }
    });

    this.submitTarget.disabled = !valid;
  }

  format(value, precision) {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });
  }
}
